export default {
  title: 'Your own domain',
  description:
    "Run your team's apps on a domain you own instead of the shared address. Connect the domain once: the dashboard, orders portal, website editor and website studio each get an address under it.",
  read_only_description: 'The domain this partner runs their apps on. Only the partner can connect or disconnect it.',
  read_only_empty: 'This partner has not connected a domain.',
  not_connected: {
    label: 'Domain',
    hint: 'The domain you own, without www — for example yourbrand.com. You then add the DNS records we show you at your domain provider.',
    placeholder: 'yourbrand.com',
    connect: 'Connect',
  },
  apps: {
    dashboard: 'Dashboard',
    oms: 'Orders portal',
    storefront: 'Website editor',
    website_studio: 'Website studio',
  },
  status: {
    active: 'Live',
    pending: 'Waiting for DNS',
    failed: 'Needs attention',
    disabled: 'Disconnected',
  },
  records: {
    title: 'Add these DNS records for {{root}} at your domain provider',
  },
  instructions: {
    title: 'How to add the records',
    step_provider:
      'Sign in where the DNS of {{root}} is managed — usually the company you bought the domain from, or a DNS host such as Cloudflare.',
    step_add:
      'Open the DNS settings of {{root}} and add each record below: choose the type, then copy the name and the value exactly. Leave the TTL at its default.',
    step_check:
      'Save the records, then click “{{button}}”. Most providers publish changes within minutes; some take up to 48 hours.',
    tip_name:
      'In the name field most providers want only the part before {{root}}, shown in bold. If yours asks for the full name, copy the one underneath.',
    tip_cloudflare:
      'On Cloudflare, set the CNAME records to “DNS only” (grey cloud). A proxied record hides the CNAME, so the domain cannot be verified.',
    tip_existing: 'Leave your existing records for {{root}} and www as they are — your website keeps working.',
  },
  summary: {
    live: 'Your dashboard is live on {{host}}.',
    pending: 'We check your DNS records regularly. New records can take up to 48 hours to be found.',
    failed: 'Some records could not be verified. Fix the records marked below, then check again.',
    relogin: 'Once {{host}} is live, your team signs in there. The first visit asks them to log in again.',
  },
  buttons: {
    check_again: 'Check again',
    disconnect: 'Disconnect',
    retry: 'Try again',
  },
  disconnect_confirm: {
    title: 'Disconnect {{root}}?',
    description: 'Your apps go back to the shared address, and links on {{root}} stop working.',
    ok: 'Disconnect',
  },
  toasts: {
    load_error: 'Could not load your domain.',
    load_error_read_only: "Could not load this partner's domain.",
    connected: 'Domain connected. Add the DNS records below.',
    connect_failed: 'Could not connect the domain.',
    check_started: 'Checking your DNS records.',
    check_failed: 'Could not start a check. Try again in a minute.',
    disconnected: 'Domain disconnected.',
    disconnect_failed: 'Could not disconnect the domain.',
  },
};
